import { __assign } from "tslib";
import React from 'react';
import { Transition } from 'react-transition-group';
var DURATION = 200;
var transitionFade = {
    entering: { opacity: 0 },
    entered: { opacity: 1 },
};
var defaultAnimationProps = {
    timeout: { enter: 0, exit: DURATION },
    mountOnEnter: true,
    unmountOnExit: true,
    appear: true,
};
export var Animation = React.forwardRef(function (_a, ref) {
    var isVisible = _a.isVisible, children = _a.children, _b = _a.animationProps, animationProps = _b === void 0 ? defaultAnimationProps : _b, onExitAnimationEnd = _a.onExitAnimationEnd;
    return (React.createElement(Transition, __assign({ nodeRef: ref, in: isVisible }, defaultAnimationProps, animationProps, { onExited: onExitAnimationEnd }), function (state) {
        return children(__assign({ transition: "opacity ".concat(DURATION, "ms ease-in"), opacity: 0 }, transitionFade[state]));
    }));
});
Animation.displayName = 'Animation';
//# sourceMappingURL=Animation.js.map